// Imports in this file have to relative because import aliases are not supported in Nuxt server

import BaseService from './BaseService';
export default class Service extends BaseService {
  constructor(variables?: { req?: PortalRootIncomingMessage }) {
    super(variables);
  }
}
